import api from '../../plugins/api';

const ensureContainer = (params) => {
  return api.post('/api/crm/cars/ensureContainer', params);
};

export default ensureContainer;
